(() => {
  const names = /\b(SunKids|The\s+Natural\s+SKN\s+Company)\b(?:[™®]|\(TM\))*/gi;
  const skip = 'script,style,textarea,input,select,option,code,pre,svg,[contenteditable], [data-skn-brand]';
  const normalize = value => value.replace(names, (_, name) => /^the\s/i.test(name) ? name + '™' : 'SunKids™');
  function textNode(node) {
    if (!node.parentElement || node.parentElement.closest(skip)) return;
    const value = node.nodeValue;
    names.lastIndex = 0;
    if (!names.test(value)) return;
    names.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let end = 0;
    for (const match of value.matchAll(names)) {
      fragment.append(value.slice(end, match.index));
      const span = document.createElement('span');
      span.dataset.sknBrand = '';
      if (/^the\s/i.test(match[1])) {
        const pieces = match[1].match(/^(The\s+)(Natural\s+SKN)(\s+Company)$/i);
        span.append(pieces[1]);
        const strong = document.createElement('strong');
        strong.style.fontWeight = '700';
        strong.textContent = pieces[2];
        span.append(strong, pieces[3] + '™');
      } else {
        span.style.fontWeight = '700';
        span.textContent = 'SunKids™';
      }
      fragment.append(span);
      end = match.index + match[0].length;
    }
    fragment.append(value.slice(end));
    node.replaceWith(fragment);
  }
  function scan(root) {
    if (root.nodeType === 3) { textNode(root); return; }
    if (root.nodeType !== 1 || root.closest(skip)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(textNode);
    [root, ...root.querySelectorAll('[alt],[aria-label],[title]')].forEach(el => {
      if (el.closest(skip)) return;
      ['alt', 'aria-label', 'title'].forEach(attr => {
        if (el.hasAttribute(attr)) {
          const value = el.getAttribute(attr), next = normalize(value);
          if (next !== value) el.setAttribute(attr, next);
        }
      });
    });
  }
  function start() {
    scan(document.body);
    document.title = normalize(document.title);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') scan(record.target);
        else record.addedNodes.forEach(scan);
      }
    }).observe(document.body, {childList:true,subtree:true,characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
